import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-link\"><path d=\"M10.879 6.05L15 1.93A5.001 5.001 0 0122.071 9l-4.121 4.121a1 1 0 01-1.414-1.414l4.12-4.121a3 3 0 10-4.242-4.243l-4.121 4.121a1 1 0 11-1.414-1.414zm2.242 11.9L9 22.07A5 5 0 111.929 15l4.121-4.121a1 1 0 011.414 1.414l-4.12 4.121a3 3 0 104.242 4.243l4.121-4.121a1 1 0 111.414 1.414zm-8.364-.122l13.071-13.07a1 1 0 011.415 1.414L6.172 19.242a1 1 0 11-1.415-1.414z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol